import React from 'react'
import './index.scss'

const CustomTitle1 = (props) => {
  const { title, titleIcon, textClor } = props
  let defaultIcon =
    'http://baleen-cdn-g.bybieyang.com/lego/img/img_titlebg%403x.png'
  return (
    <div className="lego_customTitleContent">
      <div className="leftIconBox">
        <img src={titleIcon || defaultIcon} alt=""></img>
      </div>
      <div
        className="titleTextBox"
        style={{ color: textClor === 'black' ? '#333' : '#fff' }}
      >
        {title}
      </div>
      <div className="rightIconBox">
        <img src={titleIcon || defaultIcon} alt=""></img>
      </div>
    </div>
  )
}

export default CustomTitle1
